export default {
  user: {
    first_name: new String,
    last_name: new String,
  },
  organisation: {
    name: new String,
  },
  subscription: {
    name: new String,
    code: new String,
    visit: new Boolean,
  },
  loaded: false
};
